$(function () {
    var itemsPerPage = 12;
    var visibleItems = itemsPerPage;

    $('.productClick.grid__item:gt(' + (visibleItems - 1) + ')').hide();

    function loadMoreItems() {
        visibleItems += itemsPerPage;
        $('.productClick.grid__item:lt(' + visibleItems + ')').show();

        if (visibleItems >= $('.productClick.grid__item').length) {
            $('#load-more').hide();
        }
    }

    function isContent50PercentVisible() {
        var windowHeight = $(window).height();
        var docHeight = $(document).height();
        var scrollThreshold = docHeight - windowHeight - windowHeight * 0.8; // 80% threshold

        return $(window).scrollTop() >= scrollThreshold;
    }

    var scrollTimeout;
    $(window).scroll(function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
            if (isContent50PercentVisible()) {
                loadMoreItems();
            }
        }, 200); // Adjust the delay time as needed
    });

    function initReadMore(selector, threshold) {
        const description = document.querySelector(selector);
        if (description) {
            // Add gradient overlay
            const overlay = document.createElement('div');
            overlay.className = 'gradient-overlay';
            description.appendChild(overlay);
            
            // Add read more button
            const button = document.createElement('button');
            button.className = 'read-more-btn';
            button.textContent = 'Read More';
            description.parentNode.insertBefore(button, description.nextSibling);
            
            // Check if content needs truncation
            const needsButton = description.scrollHeight > threshold;
            if (!needsButton) {
                button.style.display = 'none';
                description.classList.remove('truncate');
            }
    
            // Toggle expansion on click
            button.addEventListener('click', () => {
                const isExpanded = description.classList.contains('expanded');
                description.classList.toggle('expanded');
                if(isExpanded) {
                    if(selector == ".collection-benefits-content.truncate") {
                        const offsetY = $(window).width() < 768 ? $('header').height() : $('sticky-header').height() +10;
                        $('html, body').scrollTop($("#collection-benefits").offset().top - offsetY);
                    }
                }
                button.textContent = isExpanded ? 'Read More' : 'Read Less';
            });
        }
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        initReadMore('.collection-description.truncate', 60);
        initReadMore('.collection-benefits-content.truncate', 150);
    }
});


document.addEventListener('algolia.hooks.initialize', function() {
    const updateCollectionHits = (collectionId, newHits) => {
        const storageKey = `collection_${collectionId}`;
        const currentHits = localStorage.getItem(storageKey);
        
        if (!currentHits || parseInt(newHits) > parseInt(currentHits)) {
          localStorage.setItem(storageKey, newHits);
          return newHits;
        }
        
        return currentHits;
      }
      
    const getColorSwatches = (hit) => {
        const colorSwatches = hit.meta.linkgroup?.color_swatches;
        const topColorSwatches = hit.meta.linkgroup?.topcolor_swatches;
        const swatches = colorSwatches || topColorSwatches;
        const swatchesParsed = swatches ? JSON.parse(swatches) : [];

        const swatchesCache = hit?.meta?.linkgroup?.swatches_cache? JSON.parse(hit?.meta?.linkgroup?.swatches_cache) : [];
      
        if (swatchesParsed.length > 0) {
          // Find the index of the item with matching handle
          const index = swatchesParsed.findIndex(({ handle }) => handle === hit.handle);
      
          if (index !== -1) {
            // If found, move it to the front
            const matchingItem = swatchesParsed[index];
            swatchesParsed.splice(index, 1); // Remove the item from its current position
            swatchesParsed.unshift(matchingItem); // Add it to the front
          }
      
          /// Generate the HTML for each item in the sorted array
          return swatchesParsed
            .sort((a, b) => {
              const colourA = (a.colour || '').toLowerCase();
              const colourB = (b.colour || '').toLowerCase();
              return colourA.localeCompare(colourB);
            })
            .map(({ handle, colour, imageUrl, title, price, compareAtPrice }) => {
                const colorHandle = `${window.location.origin}/products/${handle}`;
                const colorPath = `${window.location.origin}/cdn/shop/files/${colour.replaceAll(' ', '-').toLowerCase()}-swatch_40x40.gif`;
                const swatchCache = swatchesCache.find(({ handle: swatchHandle }) => swatchHandle === handle);
                const dataBorder = (colour || '').includes('White') ? 'data-border' : '';
                
                return `<a
                    class="color__item-main"
                    href="${colorHandle}"
                    data-href="${colorHandle}"
                    data-image="${swatchCache?.imageUrl ?? ''}"
                    data-title="${swatchCache?.title ?? ''}"
                    data-price="${swatchCache?.price ?? ''}"
                    data-comparePrice="${swatchCache?.compareAtPrice ?? ''}"
                    ${swatchCache?.handle == hit.handle ? 'data-clicked="true"' : ''}
                ><span class="${swatchCache?.handle == hit.handle ? 'active' : ''}"><img src="${colorPath}" width="26" height="26" ${dataBorder}></img></span></a>`;
            }).join('');
        }
      
        return ''; // Return empty string if no swatches are found
    };

     const getColorSwatchImageUrl = (colorName) => {
        if (!colorName) return null;
        const cleanColorName = colorName.replaceAll(' ', '-').toLowerCase();
        return `${window.location.origin}/cdn/shop/files/${cleanColorName}-swatch_40x40.gif`;
    };

    // facets
    algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function(params, facet) {
        if (facet.title === 'Colour/Finish' || 
            facet.name === 'colour' || 
            facet.name === 'color' ||
            facet.title.toLowerCase().includes('color') || 
            facet.title.toLowerCase().includes('colour')) {
            
            return {
                ...params,
                sortBy: ['name:asc'],
                templates: {
                    item(data, { html }) {
                        const { count, cssClasses, isRefined, label, value } = data;
                        const swatchImageUrl = getColorSwatchImageUrl(label);
                        
                        return html`
                            <label 
                                class="${cssClasses.label}" 
                                data-color-swatch="${swatchImageUrl}"
                                data-color-name="${label.toLowerCase().replace(/\s+/g, '-')}"
                                style="--swatch-url: url('${swatchImageUrl}')"
                            >
                                <input 
                                    type="checkbox" 
                                    class="${cssClasses.checkbox}" 
                                    ${isRefined ? 'checked' : ''}
                                />
                                ${label}
                                <span class="${cssClasses.count}">
                                    ${algoliaShopify.helpers.formatNumber(count)}
                                </span>
                            </label>
                        `;
                    }
                }
            };
        }
        
        if (facet.title === 'Seats' || 
            facet.name === 'seats' ||
            facet.title.toLowerCase().includes('seat') ||
            facet.title.toLowerCase().includes('size') ||
            facet.title.toLowerCase().includes('capacity')) {

            return {
                ...params,
                sortBy: ['value:asc'],
                transformItems(items) {
                    return items.map(item => {
                        // Safely convert to integer only if value is numeric
                        // Keep as string if it's not numeric (e.g., "King Size", "Double")
                        const valueStr = String(item.value || '');
                        const numericValue = parseInt(valueStr, 10);
                        const isNumeric = !isNaN(numericValue) && valueStr.trim() !== '' && /^\d+$/.test(valueStr.trim());

                        return {
                            ...item,
                            value: isNumeric ? numericValue : valueStr,
                        };
                    });
                },
            };
        }

        if (facet.title === 'Price range' || 
            facet.name === 'price_range' ||
            facet.title.toLowerCase().includes('price range')) {
            
            return {
                ...params,
                sortBy: ['name:asc'], 
                transformItems(items) {
                    return items.map(item => {
                        const priceRange = item.value.split(':');
                        const minPrice = parseInt(priceRange[0]);
                        const maxPrice = parseInt(priceRange[1]);

                        return {
                            ...item,
                            value: item.value,
                            label: `${formatMoney(minPrice)} - ${formatMoney(maxPrice)}`, 
                            minPrice: minPrice,
                            maxPrice: maxPrice,
                            sortKey: minPrice
                        };
                    }).sort((a, b) => a.sortKey - b.sortKey); 
                },
            };
        }
        
        return {
            ...params,
            sortBy: ['name:asc']
        };
    });

    
    // search and filter widgets
    algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
        const urlParams = new URLSearchParams(window.location.search);
        const sortBy = urlParams.get('sortBy');
        
        // Get collection handle for default sort logic
        const collectionPath = window.location.pathname;
        const collectionMatch = collectionPath.match(/\/collections\/([^\/]+)/);
        const collectionHandle = collectionMatch ? collectionMatch[1] : null;
        
        // Set default sort for black-friday-2025 collection if no sort parameter exists
        let defaultSortValue = sortBy;
        if (!sortBy && collectionHandle === 'black-friday-2025') {
            defaultSortValue = Shopify?.shop == 'laura-james-ireland.myshopify.com' ? 'shopify_products_price_desc' : 'uk_shopify_products_price_desc';
        }
        
        const selectedSort = algoliaShopify.sortOrders.find(item => item.value === defaultSortValue) || algoliaShopify.sortOrders[0]

        return html`
            <div class="ais-page collection-wrapper">
                <h1 class="ais-h2${ pageTemplate?.includes('collection') ? ' hidden' : '' }">${algoliaShopify.translations.searchTitle}</h1>
                <div class="ais-input${ pageTemplate?.includes('collection') && !enableSearchCollection ? ' hidden' : '' }">
                    <div class="ais-search-box-container"></div>
                    <div class="ais-input-button">
                    <div class="ais-clear-input-icon"></div>
                    </div>
                </div>
                <div class="ais-facets-button hidden">Show filters</div>

                <div class="ais-facets collection-facets">
                    <div class="collection-facets-header">
                        <h4>Filter & Sort</h4>
                        <div class="ais-stats-container-side"></div>
                        <div class="ais-stats-container-simple"></div>
                        <div class="collection-facets-header__clear-all">Clear All</div>
                        <a href="javascript:void(0)" class="collection-facets-close">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.50012 0.0237045C0.18762 0.0862045 -0.0623802 0.398674 0.00011984 0.773674C0.00011984 0.898674 0.0626198 1.0237 0.18762 1.1487L9.12512 10.0862L0.18762 18.8987C-0.0623801 19.1487 -0.0623801 19.5237 0.18762 19.7737C0.43762 20.0237 0.81262 20.0237 1.06262 19.7737L10.0001 10.8987L18.9376 19.8362C19.1876 20.0862 19.5626 20.0862 19.8126 19.8362C20.0626 19.5862 20.0626 19.2112 19.8126 18.9612L10.8751 10.0237L19.8126 1.08617C20.0626 0.836174 20.0626 0.461197 19.8126 0.211197C19.6876 0.0861969 19.5001 0.0237045 19.3751 0.0237045C19.1876 0.0237045 19.0626 0.0861969 18.9376 0.211197L10.0001 9.0862L1.06262 0.148674C0.93762 0.023674 0.75012 -0.0388184 0.62512 -0.0388184C0.56262 0.0236816 0.56262 0.0237045 0.50012 0.0237045Z" fill="#817264"></path>
                            </svg>
                        </a>
                    </div>
                    <div class="collection-facets-body">
                        <div class="ais-facets-sort">
                            ${html`
                            ${algoliaShopify.translations.sortBy}
                            <span class="ais-sort-orders-container"></span>
                            `}
                        </div>
                        <div class="ais-clear-refinements-container hidden"></div>
                        <div class="ais-current-refined-values-container"></div>
                        ${data.facets
                            .filter(facet => facet.type !== 'hidden')
                            .map(facet =>
                                    html`
                                    <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                                        <label
                                            for="${facet.escapedName}"
                                            class="ais-range-slider--header ais-facet--header ais-header collapse">${facet.title}</label>
                                        <input
                                            class="ais-dropdown-checkbox"
                                            type="checkbox"
                                            id="${facet.escapedName}"
                                            name="dropdown" checked/>
                                        <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                                    </div>
                                    `
                            )
                        }
                    </div>
                    <div class="collection-facets-footer">
                        <button type="button" class="collection-facets-clear-all">Clear All</button>
                        <button type="button" class="collection-facets-apply button">Apply</button>
                        <button type="button" class="collection-facets-apply button view-stats">View Products <span class="collection-facets-footer__stats"></span></button>
                    </div>
                </div>

                <div class="ais-block collection-wrapper-item-list">
                    <div class="ais-search-header collection-wrapper__search-header">
                        <div class="collection-wrapper__facets-display">
                            <span class="collection-wrapper__filter-label">Filter:</span>
                            <span class="collection-wrapper__filter-label-mobile">
                                <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M5.91465 3.5C5.70873 4.0826 5.15311 4.5 4.5 4.5C3.84689 4.5 3.29127 4.0826 3.08535 3.5C3.03008 3.34361 3 3.17532 3 3C3 2.82468 3.03008 2.65639 3.08535 2.5C3.29127 1.9174 3.84689 1.5 4.5 1.5C5.15311 1.5 5.70873 1.9174 5.91465 2.5C5.96992 2.65639 6 2.82468 6 3C6 3.17532 5.96992 3.34361 5.91465 3.5ZM6.94999 2.5C6.71836 1.35888 5.70948 0.5 4.5 0.5C3.29052 0.5 2.28164 1.35888 2.05001 2.5H0.5V3.5H2.05001C2.28164 4.64112 3.29052 5.5 4.5 5.5C5.70948 5.5 6.71836 4.64112 6.94999 3.5H14.5V2.5H6.94999ZM9.08535 10.5C9.29127 11.0826 9.84689 11.5 10.5 11.5C11.1531 11.5 11.7087 11.0826 11.9146 10.5C11.9699 10.3436 12 10.1753 12 10C12 9.82468 11.9699 9.65639 11.9146 9.5C11.7087 8.9174 11.1531 8.5 10.5 8.5C9.84689 8.5 9.29127 8.9174 9.08535 9.5C9.03008 9.65639 9 9.82468 9 10C9 10.1753 9.03008 10.3436 9.08535 10.5ZM8.05001 9.5C8.28164 8.35888 9.29052 7.5 10.5 7.5C11.7095 7.5 12.7184 8.35888 12.95 9.5H14.5V10.5H12.95C12.7184 11.6411 11.7095 12.5 10.5 12.5C9.29052 12.5 8.28164 11.6411 8.05001 10.5H0.5V9.5H8.05001Z"
                                    fill="black"
                                />
                                </svg>

                                Filter and sort
                            </span>
                            <div class="collection-wrapper__facets">
                                ${ data.facets
                                    .filter(facet => facet.type !== 'hidden')
                                    .map(facet => html`<div class="collection-wrapper__facet facet-${facet.escapedName}">${facet.title}</div>`) 
                                }
                            </div>

                            <div class="ais-stats-container"></div>
                        </div>
                        
                        <div class="ais-change-display hidden">
                            <span class="ais-change-display-block ais-change-display-selected">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
                                </svg>
                            </span>
                            <span class="ais-change-display-list">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                                </svg>
                            </span>
                        </div>
                        <div class="ais-sort collection-sort">
                            <span class="collection-sort__label">${algoliaShopify.translations.sortBy}:</span>
                            <span class="collection-sort__value">${selectedSort.label}</span>
                            <span class="collection-sort__icon"></span>
                        </div>
                    </div>
                    <div class="ais-hits-container ais-results-as-block"></div>
                </div>
                <div class="ais-pagination-container"></div>
            </>
        `;
    });

    // stats widget
    algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function(_defaultTemplate, data, html) {
        const totalHits = updateCollectionHits(`${algoliaShopify.current_collection_id}`, data.nbHits)

        const statsHTML = html`
            ${data.hasOneResult &&
                html`
                <span class="ais-stats--nb-results collection__stats">
                    1 Product found
                </span>
                `}
            ${data.hasManyResults &&
                html`
                <span class="ais-stats--nb-results collection__stats">
                    ${' '} ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '}
                    Products
                </span>
                `}
            `;
        const statsPanel = document.querySelector('.ais-stats-container-side')

        if ( statsPanel ) {
            statsPanel.innerHTML = `<span class="ais-stats--nb-results collection__stats">
                    ${' '} ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '} of 
                    ${totalHits} Products 
                </span>`
        }

        const statsSimple = document.querySelector('.ais-stats-container-simple')

        if ( statsSimple ) {
            statsSimple.innerHTML = `<span class="ais-stats--nb-results collection__stats">
                    ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '} Products 
                </span>`
        }

        const statsFooter = document.querySelector('.collection-facets-footer__stats')

        if ( statsFooter ) {
            statsFooter.innerHTML = `<span class="ais-stats--nb-results collection__stats">
                    ${' '} (${algoliaShopify.helpers.formatNumber(data.nbHits)}) 
                </span>`
        }

        return statsHTML
    });
      
    // product gallery widget
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components, trackSearchAttribution) {
        const currentDomain = Shopify.shop;
        let ratingCount, ratingValue;

        if (currentDomain !== 'laura-james-ireland.myshopify.com') {
            ratingCount = hit?.meta?.yotpo?.reviews_count || 0;
            ratingValue = hit?.meta?.yotpo?.reviews_average || 0
        } else {
            const reviews = hit?.meta?.reviews || {};
            ratingCount = reviews.rating_count || 0;
            ratingValue = reviews.rating ? JSON.parse(reviews.rating)?.value || 0 : 0;
        }

        const percentage = (ratingValue / 5) * 100;
        const hideStarRatings = ratingCount === undefined || ratingCount < window.reviewsCountThreshold;
        const colorSwatches = getColorSwatches(hit); 
        const hasFreeGift = !!hit?.meta?.custom?.hasfreegift || '';
        const hasFreeFurnitureCover = !!hit?.meta?.custom?.hasfreefurniturecover || '';
        const justInBadgeMode = window.normalizeJustInBadgeMode(
          hit?.meta?.custom?.just_in_badge_mode
        );
        const customBadgeEnabled = window.normalizeCustomBadgeEnabled(
          hit?.meta?.custom?.enable_custom_badge
        );
        const publishedAt = hit.published_at || hit.created_at || '';
        const freeGiftBadgeEnabled = window.freeGiftBadgeEnabled || false;

        let badgeMessage = ''; 

        const badgeMessages = {
            'isEOL': 'Discontinued',
            'status:OnHold': 'Sold out',
            'status:Outlet': 'Sold out',
            'seasonal': 'Sold for season'
        };

        // Check if the inventory is unavailable
        if (!hit.inventory_available) {
            // Find the first matching tag in the dictionary
            badgeMessage = 'Back Soon'; 

            for (const [tag, message] of Object.entries(badgeMessages)) {
                if (hit.tags.includes(tag)) {
                    badgeMessage = message;
                    break;
                }
            }
        }

        return html`
        <div
            class="ais-hit ais-product productClick"
            data-product-id="${hit.id}"
            data-item_id="${hit.id}"
            data-item_name="${hit.title}"
            data-price="${hit.price}"
            data-item_brand="${hit.vendor}"
            data-item_category="${hit.product_type}"
            data-item_list_name="${hit.title}"
            data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            data-handle="${hit.handle}"
            data-variant-id="${hit.objectID}"
            data-distinct="${hit._distinct}"
            data-image="${hit.image}"
            data-tags="${hit.tags.toString()}"
            data-available="${hit.inventory_available}"
            data-has_freegift="${hasFreeGift}"
            data-has_freefurniturecover="${hasFreeFurnitureCover}"
            data-usp1="${hit.meta?.lj_marketing?.usp1 || ''}"
            data-usp2="${hit.meta?.lj_marketing?.usp2 || ''}"
            data-usp3="${hit.meta?.lj_marketing?.usp3 || ''}"
            data-average_rating="${ratingValue}"
            data-reviews_count="${ratingCount}"
            data-parasol_handles="${hit.meta?.linkgroup?.parasol || ''}"
            data-has_parasol_date="${hit.meta?.custom?.has_parasol_date || ''}",
            data-swatches_cache="${hit.meta?.linkgroup?.swatches_cache || ''}"
            data-just_in_badge_mode="${justInBadgeMode}"
            data-enable_custom_badge="${customBadgeEnabled}"
            data-published_at="${publishedAt}"
        >

            <a class="hit-picture"
                data-algolia-index="${hit.index}"
                data-algolia-position="${hit.productPosition}"
                data-algolia-queryid="${hit.queryID}"
                data-algolia-objectid="${hit.objectID}"
                href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                >
                <img
                    class="ais-hit--picture"
                    src="${algoliaShopify.helpers.largeImage(hit)}"
                    alt="${hit.title} - ${hit.variant_title}"
                />


                <div class="ais-product__badges">
                    <div class="badge badge--sold-out badge--top badge--right color-${soldOutBadgeColorScheme}">${badgeMessage}</div>
                    ${ freeGiftBadgeEnabled
                        ? freeItemSnippet(hasFreeFurnitureCover, hasFreeGift, hit.inventory_available, html) 
                        : ''
                    }
                    ${ window.customBadgeSnippet(customBadgeEnabled, html) }
                    ${ window.justInBadgeSnippet(justInBadgeMode, publishedAt, html, customBadgeEnabled) }
                </div>
            </a>
    
            <div class="ais-hit--details">
                <p class="ais-hit--title">
                    <a
                    data-algolia-index="${hit.index}"
                    data-algolia-position="${hit.productPosition}"
                    data-algolia-queryid="${hit.queryID}"
                    data-algolia-objectid="${hit.objectID}"
                    href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                    title="${algoliaShopify.helpers.fullTitle(
                        hit.title,
                        hit._distinct,
                        hit.variant_title
                    )}"
                    >
                        <span class="ais-hit--title-text">
                            ${components.Highlight({ attribute: 'title', hit })}
                            ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
                        </span>
                    </a>
                </p>
                    
                <div class="product__color" innerHTML="${colorSwatches}"></div>

                <p class="ais-hit--price">
                    ${hit.compare_at_price > 0 &&
                    html`
                        <span class="ais-hit--price-striked"><span
                            >${algoliaShopify.helpers.displayStrikedPrice(
                            hit.price,
                            hit.compare_at_price
                            )}</span>
                        </span>
                    `}
                    <span class="ais-hit--price-original">${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</span>
                </p>

                <div class="stars-container" style="${hideStarRatings ? 'display: none;' : ''}">
                    <div class="stars-content">
                        <p class="star-ratings">
                            <!-- Important: The empty stars must come first in the DOM -->
                            <span class="empty-ratings empty-ratings-init">★★★★★</span>
                            <!-- The fill-ratings span must come after -->
                            <span class="fill-ratings fill-ratings-init" style="width: ${percentage}%;">★★★★★</span>
                        </p>
                        <span class="rating-count-text">${ratingCount}</span>
                    </div>
                </div>
            </div>
        </div>`;
    });

    // remove default widget hits and paginatioon
    algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function(
        defaultWidgets
    ) {
        // Find 'ais.hits'
        const hitsWidget = defaultWidgets.find(
            widget => widget.$$widgetType === 'ais.hits'
        );
        // Find 'ais.pagination'
        const paginationWidget = defaultWidgets.find(
            widget => widget.$$widgetType === 'ais.pagination'
        );
        
        return [hitsWidget, paginationWidget];
    });
    
    const { infiniteHits } = window.instantsearch.widgets;
    
    algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
        const infiniteHitsWidget = infiniteHits({
            container: '.ais-hits-container',
            templates: {
                item(hit, { html, components }) {
                    return window.algoliaShopify.instantsearch.templates.instantSearchProductTemplate(
                        hit,
                        html,
                        components,
                        window.algoliaShopify
                    );
                },
                empty(results, { html }) {
                    return window.algoliaShopify.instantsearch.templates.instantSearchNoResultTemplate(
                        html,
                        window.algoliaShopify
                    );
                },
                showMoreText(data, { html }) {
                    return html`<span>${algoliaShopify.translations.showMore}</span>`;
                },
            },
            transformItems: items => {
                const transformedItems = items.map(item => ({
                    ...item,
                    _distinct: window.algoliaShopify.instantsearch.distinct,
                    can_order:
                        item.inventory_policy === 'continue' || item.inventory_quantity > 0,
                    queryID: item.__queryID,
                    productPosition: item.__position,
                    index: window.algoliaShopify.instantsearch.search.mainIndex.getIndexName(),
                }));
                return transformedItems;
            },
        });
        
        return [infiniteHitsWidget];
    });

    algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(defaultFilter) {
        // Extract the collection handle from the URL path
        const collectionPath = window.location.pathname;
        const collectionMatch = collectionPath.match(/\/collections\/([^\/]+)/);
        const collectionHandle = collectionMatch ? collectionMatch[1] : null;

        // If we're on a collection page and have a filter containing collection_ids
        if (collectionHandle && defaultFilter && defaultFilter.includes('collection_ids:')) {
          // Extract the collection ID from the filter
          const collectionIdMatch = defaultFilter.match(/collection_ids:"?(\d+)"?/);
          
          if (collectionIdMatch && collectionIdMatch[1]) {
            // Replace collection_ids filter with collections filter using the handle from URL
            return defaultFilter.replace(
              /collection_ids:"?\d+"?/, 
              `collections:"${collectionHandle}"`
            );
          }
        }
        
        return defaultFilter;
    });

    algoliaShopify.hooks.registerHook("beforeInstantSearchConfigurationOptions",function (options) {
        return {
        ...options,
                searchFunction: searchFunctionHelper => {
                    // get current page number
                    const page = searchFunctionHelper.getPage();

                    // get collection handle
                    const collectionPath = window.location.pathname;
                    const collectionMatch = collectionPath.match(/\/collections\/([^\/]+)/);
                    const collectionHandle = collectionMatch ? collectionMatch[1] : null;

                    // check if in a collection page
                    if(collectionHandle) {
                        if (collectionHandle === 'outlet') {
                            // get only outlet products that are available and disable all rules for this collection
                            const filters = `collections:"${collectionHandle}" AND inventory_available:true`;
                            searchFunctionHelper.setQueryParameter('filters', filters);
                            searchFunctionHelper.setQueryParameter('enableRules', false);
                        } else if (collectionHandle === 'black-friday-2025') {
                            // Set default sort to price low to high for black-friday-2025 collection
                            const urlParams = new URLSearchParams(window.location.search);
                            const currentSort = urlParams.get('sortBy');
                            
                            // Only set default sort if no sort parameter is already specified
                            if (!currentSort) {
                                // Use setIndex to change to the price ascending index
                                const defaultSortValue = Shopify?.shop == 'laura-james-ireland.myshopify.com' ? 'shopify_products_price_asc' : 'uk_shopify_products_price_asc';
                                searchFunctionHelper.setIndex(defaultSortValue);
                            } else {
                                // If there is a sort parameter, make sure we use the correct index
                                searchFunctionHelper.setIndex(currentSort);
                            }
                            
                            searchFunctionHelper.setQueryParameter('filters', `collections:"${collectionHandle}"`);              
                            searchFunctionHelper.setQueryParameter('enableRules', true);
                        } else {
                            // enable all rules for this collection and restore original filters
                            searchFunctionHelper.setQueryParameter('filters', `collections:"${collectionHandle}"`);              
                            searchFunctionHelper.setQueryParameter('enableRules', true);
                        }

                        searchFunctionHelper.setQueryParameter('ruleContexts', [`${collectionHandle}`,"shopify_default_collection"]);
                    }
                    
                    searchFunctionHelper.setQueryParameter('distinct', true);
                    
                    // restore current page
                    searchFunctionHelper.setPage(page);
                    searchFunctionHelper.search();
                },
            }
        }
    );
});

document.body.addEventListener("click", function (event) {
    const element = event.target;
    const facetPanel = document.querySelector('.ais-facets.collection-facets');
    const body = document.body;

    if (body.classList.contains('facet-panel-open') && 
        !element.closest('.ais-facets.collection-facets') &&
        !element.closest('.ais-RefinementList-item') &&
        !element.closest('.ais-current-refined-values--item')) {
            
        facetPanel.classList.remove('ais-facets__shown');
        body.classList.remove('facet-panel-open');
        
    } else {
        // Check for opening triggers
        if (element.closest(".collection-wrapper__facet") || 
            element.closest(".collection-sort") || 
            element.closest(".collection-wrapper__filter-label-mobile")) {
            facetPanel.classList.add('ais-facets__shown');
            body.classList.add('facet-panel-open');
        }

        // Check for explicit close/apply buttons
        if (element.closest(".collection-facets-close") || 
            element.closest(".collection-facets-apply")) {
            facetPanel.classList.remove('ais-facets__shown');
            body.classList.remove('facet-panel-open');
        }

        // Handle clear all
        if (element.closest(".collection-facets-clear-all") || 
            element.classList.contains("collection-facets-header__clear-all")) {
            const clearAll = document.querySelector('.ais-ClearRefinements-button');
            clearAll.click();
        }

        if (element.classList.contains("ais-range-slider--header")) {
            element.classList.toggle('collapse')
        }
    }
});

let previousWindowWidth = window.innerWidth;

window.addEventListener('resize', function() {
    const currentWindowWidth = window.innerWidth;
    const facetPanel = document.querySelector('.ais-facets.collection-facets');
    const body = document.body;
    
    // Check if we crossed the 991px breakpoint
    const crossedBreakpoint = (previousWindowWidth <= 991 && currentWindowWidth > 991) || 
                             (previousWindowWidth > 991 && currentWindowWidth <= 991);
    
    // Only close if we crossed the breakpoint and the facet panel is open
    if (crossedBreakpoint && facetPanel && facetPanel.classList.contains('ais-facets__shown')) {
        facetPanel.classList.remove('ais-facets__shown');
        body.classList.remove('facet-panel-open');
    }
    
    // Update the previous width for next comparison
    previousWindowWidth = currentWindowWidth;
});

// override product redirection when product card is click
window.onload = function() {
    const newClickHandler = function(e) {
        // Check if click originated from a color swatch - if so, don't handle product card click
        if (e.target.closest('.color__item-main')) {
            return;
        }

        // Find the hit element
        let el = e.target;
        let hit;
        do {
            if (el.matches('.ais-hit')) {
                hit = el;
                break;
            }
            el = el.parentNode;
        } while (el && el !== container);
        
        if (!hit) {
            return;
        }

        // Stop the event from reaching the original handler
        e.stopPropagation();
        e.preventDefault();

        // Get all the necessary data from the hit element
        const productData = {
            handle: hit.dataset.handle,
            variantId: hit.dataset.variantId,
            distinct: hit.dataset.distinct,
            itemName: hit.dataset.item_name,
            image: hit.dataset.image,
            price: hit.dataset.price,
            compareAtPrice: hit.dataset.compare_at_price,
            itemId: hit.dataset.item_id,
            tags: hit.dataset.tags,
            available: hit.dataset.available,
            objectID: hit.dataset.algoliaObjectid,
            queryId: hit.dataset.algoliaQueryid,
            index: hit.dataset.algoliaIndex,
            position: hit.dataset.algoliaPosition,
            has_freefurniturecover: hit.dataset.has_freefurniturecover,
            has_freegift: hit.dataset.has_freegift,
            usp1: hit.dataset.usp1,
            usp2: hit.dataset.usp2,
            usp3: hit.dataset.usp3,
            average_rating: hit.dataset.average_rating,
            reviews_count: hit.dataset.reviews_count,
            parasol_handles: hit.dataset.parasol_handles,
            has_parasol_date: hit.dataset.has_parasol_date,
            swatches_cache: hit.dataset.swatches_cache,
            just_in_badge_mode: hit.dataset.just_in_badge_mode,
            enable_custom_badge: hit.dataset.enable_custom_badge,
            published_at: hit.dataset.published_at,
        };

        // Handle analytics if enabled
        if (window.algolia?.config?.analytics_enabled) {
            const clickData = {
                index: productData.index,
                eventName: 'click',
                queryID: productData.queryId,
                objectIDs: [productData.objectID]
            };

            window.algolia.saveForConversionTracking?.(clickData);
        }

        // Call algoliaClickedEvent for tracking
        algoliaClickedEvent('Product Item Clicked', [String(productData.objectID)], productData.queryId, productData.position);

        // Call trackSearchAttribution for tracking
        trackSearchAttribution(productData.queryId, productData.objectID, productData.itemId);

        // Handle recently viewed functionality
        const productItem = {
            title: productData.itemName,
            image: productData.image,
            price: productData.price,
            compare_at_price: productData.compareAtPrice,
            url: productData.handle,
            product_id: productData.itemId,
            tags: productData.tags,
            available: productData.available,
            objectID: productData.objectID,
            queryId: productData.queryId,
            position: productData.position,
            has_freefurniturecover: productData.has_freefurniturecover,
            has_freegift: productData.has_freegift,
            usp1: productData.usp1,
            usp2: productData.usp2,
            usp3: productData.usp3,
            average_rating: productData.average_rating,
            reviews_count: productData.reviews_count,
            parasol_handles: productData.parasol_handles,
            has_parasol_date: productData.has_parasol_date,
            swatches_cache: productData.swatches_cache,
            just_in_badge_mode: productData.just_in_badge_mode,
            enable_custom_badge: productData.enable_custom_badge,
            published_at: productData.published_at,
        };

        if (typeof saveRecentlyViewed === 'function') {
            saveRecentlyViewed(productItem);
        }

        let customLink = `/products/${productData.handle}`;
        if (productData.distinct !== 'true') {
            customLink += `?variant=${productData.variantId}`;
        }

        // Example: Custom navigation handling
        window.location.href = customLink;
    };

    // Find the container
    const container = document.querySelector('.ais-hits-container');

    // Function to update product card with swatch data
    const updateProductCard = function(swatch, productCard) {
        const swatchSpan = swatch.querySelector('span');
        
        // Update active state
        productCard.querySelectorAll('.color__item-main span.active').forEach(s => s.classList.remove('active'));
        swatchSpan.classList.add('active');

        // Get swatch data
        const newImageSrc = swatch.dataset.image || '';
        const newPrice = swatch.dataset.price ? algoliaShopify.formatMoney(100 * swatch.dataset.price) : swatch.dataset.price;
        // Try both camelCase and lowercase for compare price (HTML attributes are case-insensitive)
        const comparePriceRaw = swatch.dataset.comparePrice || swatch.dataset.compareprice || swatch.getAttribute('data-comparePrice') || '';
        const comparePriceFormatted = comparePriceRaw ? algoliaShopify.formatMoney(100 * comparePriceRaw) : '';

        // Update image
        const productImage = productCard.querySelector('.ais-hit--picture');
        if (productImage && newImageSrc) {
            productImage.src = newImageSrc;
            if (swatch.dataset.title) {
                productImage.alt = swatch.dataset.title;
            }
        }

        // Update title
        const titleAnchor = productCard.querySelector('.ais-hit--title');
        if (titleAnchor && swatch.dataset.title) {
            titleAnchor.querySelector('span > span').innerHTML = `<span>${swatch.dataset.title}</span>`;
            titleAnchor.title = swatch.dataset.title;
            titleAnchor.classList.add('ais-hit--variant-title');
            productCard.setAttribute('data-item_name', swatch.dataset.title);
            
            if (swatch.dataset.href) {
                titleAnchor.querySelector('a').href = swatch.dataset.href;
            }
        }

        // Update price
        const productPrice = productCard.querySelector('.ais-hit--price');
        if (productPrice && newPrice) {
            let priceHtml = '';
            if (comparePriceRaw && Number(comparePriceRaw) > Number(swatch.dataset.price || 0)) {
                priceHtml += `<span class="ais-hit--price-striked"><span>${comparePriceFormatted}</span></span>`;
            }
            priceHtml += `<span>${newPrice}</span>`;
            productPrice.innerHTML = priceHtml;
            productPrice.classList.add('ais-hit--price-variant');
        }

        // Update product card data attributes
        const href = swatch.dataset.href || '';
        const handle = href.split('/products/')[1]?.split('?')[0] || '';
        if (handle) {
            productCard.setAttribute('data-handle', handle);
        }
        if (swatch.dataset.price) {
            productCard.setAttribute('data-price', swatch.dataset.price);
        }
        if (comparePriceRaw) {
            productCard.setAttribute('data-compare_at_price', comparePriceRaw);
        } else {
            productCard.removeAttribute('data-compare_at_price');
        }
    };

    // Handle swatch tap on mobile
    const handleSwatchClick = function(e) {
        const swatch = e.target.closest('.color__item-main');
        if (!swatch) return;

        const productCard = swatch.closest('.ais-product');
        if (!productCard) return;

        //allow navigation immediately on desktop
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (!isTouchDevice) return;

        // First tap = update, Second tap = navigate on mobile
        if (swatch.hasAttribute('data-clicked')) {
            return; // Second tap - allow navigation
        }

        // First tap - prevent navigation and update
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        // Clear data-clicked from other swatches
        productCard.querySelectorAll('.color__item-main').forEach(s => s.removeAttribute('data-clicked'));
        swatch.setAttribute('data-clicked', 'true');

        // Update product card
        updateProductCard(swatch, productCard);
    };

    const handleSwatchHover = function(e) {
        const swatch = e.target.closest('.color__item-main');
        if (!swatch) return;

        const productCard = swatch.closest('.ais-product');
        if (!productCard) return;

        updateProductCard(swatch, productCard);
    };

    // Preload swatch images
    const preloadingImages = [];
    
    const preloadSwatchImages = function(productCard) {
        const swatches = productCard.querySelectorAll('.color__item-main');
        swatches.forEach(swatch => {
            const imageUrl = swatch.dataset.image;
            if (imageUrl && imageUrl !== '') {
                // Preload image
                const img = new Image();
                img.onload = img.onerror = () => {
                    // Remove from array once loaded to free memory
                    const index = preloadingImages.indexOf(img);
                    if (index > -1) preloadingImages.splice(index, 1);
                };
                img.src = imageUrl;
                preloadingImages.push(img);
            }
        });
        
        // Mark as preloaded
        productCard.setAttribute('data-images-preloaded', 'true');
    };
    
    // Adjust rootMargin based on connection speed for better performance
    const connectionSpeed = navigator.connection?.effectiveType || '4g';
    const isFastConnection = ['4g', 'wifi'].includes(connectionSpeed);
    
    const observerOptions = {
        root: null,
        rootMargin: isFastConnection ? '200px' : '50px', // Preload more on fast connections
        threshold: 0.01
    };
    
    const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const productCard = entry.target;
                
                // Only preload once per product
                if (productCard.getAttribute('data-images-preloaded') !== 'true') {
                    preloadSwatchImages(productCard);
                }
            }
        });
    }, observerOptions);
    
    // Observe all existing product cards
    const observeProductCards = function() {
        const productCards = container.querySelectorAll('.ais-product');
        productCards.forEach(card => {
            if (!card.hasAttribute('data-images-preloaded')) {
                imageObserver.observe(card);
            }
        });
    };
    
    observeProductCards();
    
    // Watch for new products being added
    let mutationTimeout;
    const productObserver = new MutationObserver((mutations) => {
        // Only process if actual product cards were added
        const hasNewProducts = mutations.some(mutation => {
            return Array.from(mutation.addedNodes).some(node => {
                return node.nodeType === Node.ELEMENT_NODE && 
                       (node.classList?.contains('ais-product') || 
                        node.querySelector?.('.ais-product'));
            });
        });
        
        if (!hasNewProducts) return; // Skip if no products added
        
        clearTimeout(mutationTimeout);
        mutationTimeout = setTimeout(() => {
            observeProductCards();
        }, 100); // Debounce by 100ms
    });
    
    productObserver.observe(container, {
        childList: true,
        subtree: true // Still needed for nested product additions
    });

    // Add event listeners
    container.addEventListener('mouseenter', handleSwatchHover, true); // Desktop hover
    container.addEventListener('click', handleSwatchClick, true); // Mobile tap + Desktop click
    container.addEventListener('click', newClickHandler, true); // Product card click
}